import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EmployeeTable.css';
import './tablestyle.css';
 
const SubmodClassTable = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const [submodClassList, setSubmodClassList] = useState([]);
  const [loading, setLoading] = useState(true);
   const navigate = useNavigate();
 
   const fetchSubmodClassList = () => {
    setLoading(true);
    fetch(`${baseUrl}/getSubModClass`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status && Array.isArray(data.data)) {
          setSubmodClassList(data.data);
        } else {
          setSubmodClassList([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching SubmodClass list:', err);
        setLoading(false);
      });
  };
 
  useEffect(() => {
    fetchSubmodClassList();
  }, []);
 
  const handleEditClick = async (id) => {
 
    navigate(`/submodclass/edit/${id}`);
  }
 
  const handleDeleteClick = async (id) => {
    if (!window.confirm('Are you sure you want to delete this SubmodClass?')) {
      return;
    }
 
    try {
      const response = await fetch(
        `${baseUrl}/deleteSubmodClassById/${id}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
 
      const result = await response.json();
 
      if (result.status) {
        alert('SubmodClass deleted successfully!');
        fetchSubmodClassList(); // refresh table
      } else {
        alert(result.message || 'Failed to delete SubmodClass.');
      }
    } catch (error) {
      console.error('Error deleting SubmodClass:', error);
      alert('An error occurred while deleting.');
    }
  };
 
  if (loading) {
    return <div>Loading SubmodClass data...</div>;
  }
 
  return (
    <div className="employee-table-container">
      <table className="employee-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>SubmodClass</th>
            <th>Status</th>
            <th>Created By</th>
            <th>Created On</th>
            <th>Modified By</th>
            <th>Modified On</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {submodClassList.length > 0 ? (
            submodClassList.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.sub_mod_class}</td>
                <td>
                  <span
                    className={`status-badge ${
                      item.status === 'A' ? 'active' : 'inactive'
                    }`}
                  >
                    {item.status === 'A' ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>{item.created_by}</td>
                <td>{item.created_on}</td>
                <td>{item.modified_by || '-'}</td>
                <td>{item.modified_on || '-'}</td>
                <td>
                  <button className="action-button edit" onClick={() => handleEditClick(item.id)}>Edit</button>
                  <button className="action-button delete"  onClick={() => handleDeleteClick(item.id)}>Delete</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                No SubmodClass data found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
 
export default SubmodClassTable;